import { SERVER_ROOT_DOMAIN } from '@/constants/index';

const $cookies = window.$cookies;

const getDomain = () => {
  if (-1 !== window.location.host.indexOf(SERVER_ROOT_DOMAIN)) {
    return SERVER_ROOT_DOMAIN;
  }
  return null;
};

export const cookieSetItemInfinity = (name, content) => {
  if (!name) return;
  $cookies.set(name, content, -1, '/', getDomain());
};

export const cookieSetItem = (name, content) => {
  if (!name) return;
  $cookies.set(name, content, null, '/', getDomain());
};

export const cookieGetItem = (name) => {
  if (!name) return;
  if (cookieHasItem(name)) {
    return $cookies.get(name);
  }
  return null;
};

export const cookieRemoveItem = (name) => {
  if (!name) return;
  $cookies.remove(name, '/', getDomain());
};

export const cookieHasItem = (name) => {
  if (!name) return false;
  return $cookies.isKey(name) || false;
};
